// extracted by mini-css-extract-plugin
export var selectedRegionRoot = "d248d5d7f080fdc2d2038a1e95112032-css";